import { GameStatus } from "../shared/constants";
import { authenticatedFetch } from "../utils/api";
import CreateEntity, { CreateEntityField } from "./CreateEntity";
import type { AdminGame } from "../types/admin";

interface CreateGameFormProps {
  onClose?: () => void;
  onSuccess?: (game: AdminGame) => void;
}

export default function CreateGameForm({ onClose, onSuccess }: CreateGameFormProps) {
  const fields: CreateEntityField[] = [
    { name: "game_name", label: "Game Name", type: "text", placeholder: "Enter game name" }
  ];

  const handleSubmit = async (values: Record<string, string>) => {
    const gameName = values.game_name?.trim() ?? "";

    if (!gameName) {
      throw new Error("Game name is required");
    }

    const res = await authenticatedFetch("/games/", {
      method: "POST",
      body: JSON.stringify({
        game_name: gameName,
        game_status: GameStatus.PRE_GAME
      })
    });

    if (!res.ok) {
      const errBody = await res.json().catch(() => ({}));
      throw new Error(errBody.detail || "Failed to create game");
    }

    const data: AdminGame = await res.json();
    onSuccess?.(data);
    return { successMessage: `Game "${data.game_name}" created successfully!` };
  };

  return (
    <CreateEntity
      title="Create Game"
      fields={fields}
      onSubmit={handleSubmit}
      onClose={onClose}
      submitLabel="Create Game"
    />
  );
}


